import Sidebar from "../components/sidebar/sidebar";
import React from "react";
import Navbar from "../components/navbar/navbar";
import { useContext } from "react";
import { AppContext } from "../Theme";
import Testsms from "../components/testsms/Testsms";
export default function Textsms() {
	const { darkmode, toggleMode } = useContext(AppContext);
	return (
		<>
			<div className="sidebar-component">
				<Sidebar mode={darkmode} toggleMode={toggleMode} />
			</div>
			<div className="navbar-component">
				<Navbar mode={darkmode} username="Nexcare" />
			</div>
			<Testsms mode={darkmode} />
		</>
	);
}
